import maharajPortrait from '../../../assets/images/maharaj-ji.png'
import { formatTimeLabel } from '../../../utils/date'

/** POST /bookings consultation_type → the pill label. */
const CONSULTATION_TYPE_LABELS = { video: 'VIDEO CALL', phone: 'PHONE CALL', inperson: 'IN-PERSON' }

export default function MaharajSummaryCard({ consultationType = 'video', selectedDate, selectedSlot, requiresSlot = true, tier, daysUntil, birthDetailsValid = true, onProceed, isSubmitting = false }) {
  const canProceed = Boolean(selectedDate && tier && (!requiresSlot || selectedSlot) && birthDetailsValid) && !isSubmitting
  const timeLabel = selectedSlot ? formatTimeLabel(selectedSlot.start_time ?? selectedSlot.time) : null

  return (
    <div className="space-y-4">
      <div className="flex items-center gap-3 h-8">
        <svg className="w-5 h-5 text-secondary" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <rect width="8" height="4" x="8" y="2" rx="1" ry="1" />
          <path strokeLinecap="round" strokeLinejoin="round" d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" />
          <path strokeLinecap="round" strokeLinejoin="round" d="m9 14 2 2 4-4" />
        </svg>
        <span className="text-[10px] font-normal uppercase tracking-widest text-primary/40">Expert Profile</span>
      </div>

      <div className="info-card relative overflow-hidden">
        <span className="corner-flourish tl" aria-hidden="true" />
        <span className="corner-flourish tr" aria-hidden="true" />
        <span className="corner-flourish bl" aria-hidden="true" />
        <span className="corner-flourish br" aria-hidden="true" />
        <div className="h-0.75 w-full bg-linear-to-r from-[#C8922A] via-[#E5A820] to-[#C8922A]" />
        <div className="p-7 sm:p-8 space-y-6">
          <div className="flex items-center justify-between gap-4 pb-6 border-b border-[#D7C29A]/20">
            <div className="flex items-center gap-4 min-w-0">
              <img
                src={maharajPortrait}
                alt="Raju Maharaj Ji"
                className="w-14 h-14 rounded-2xl object-cover shrink-0 border-2 border-secondary/30 shadow-[0_0_0_3px_rgba(242,160,7,.1)]"
              />
              <div className="min-w-0">
                <p className="text-[9px] font-normal text-secondary uppercase tracking-widest mb-1 flex items-center gap-1.5">
                  <span className="text-secondary">✦</span> Expert Profile <span className="text-secondary">✦</span>
                </p>
                <p className="text-2xl font-cinzel text-[#1C140A] leading-tight truncate">Raju Maharaj Ji</p>
                <div className="flex items-center gap-2 mt-1.5">
                  <p className="text-[10px] font-normal text-[#8B7355] uppercase tracking-widest">ID: RAJU_MAHARAJ</p>
                  <span
                    className="inline-flex items-center rounded-full px-2 py-0.5 text-[8px] font-bold uppercase tracking-widest text-[#1C140A]"
                    style={{ background: 'linear-gradient(135deg, #D4AF37 0%, #F7D08F 100%)' }}
                  >
                    VIP Access
                  </span>
                </div>
              </div>
            </div>
            <div
              className="h-12 w-12 rounded-lg flex items-center justify-center text-primary shrink-0"
              style={{ background: 'rgba(90,10,22,.06)' }}
            >
              <svg className="w-6 h-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z" />
                <path strokeLinecap="round" strokeLinejoin="round" d="m9 12 2 2 4-4" />
              </svg>
            </div>
          </div>

          <div className="space-y-6">
            <div className="flex justify-between items-center">
              <span className="text-primary/40 text-xs font-normal">Consultation Type:</span>
              <span className="meta-pill">{CONSULTATION_TYPE_LABELS[consultationType] ?? consultationType.toUpperCase()}</span>
            </div>
            <div className="flex justify-between items-end">
              <span className="text-primary/40 text-xs pb-1 font-normal">System Fee:</span>
              <div className="text-right">
                {tier ? (
                  <>
                    <span className="font-cinzel font-bold text-4xl block text-gradient-gold">₹{tier.price.toLocaleString('en-IN')}</span>
                    <span className="text-[10px] uppercase tracking-widest text-[#8B7355] mt-1 block">{tier.label} · {daysUntil} day{daysUntil === 1 ? '' : 's'} out</span>
                  </>
                ) : (
                  <span className="font-cinzel font-bold text-3xl block text-secondary">Select Date</span>
                )}
              </div>
            </div>

            {selectedDate && (
              <div className="flex justify-between items-center p-3 bg-muted/30 rounded-lg border border-border/40">
                <span className="text-primary/40 text-[10px] font-normal uppercase">Synced Date</span>
                <span className="text-primary font-normal text-xs">
                  {selectedDate.toLocaleDateString('en-IN', { month: 'long', day: 'numeric', year: 'numeric' })}
                </span>
              </div>
            )}
            {timeLabel && (
              <div className="flex justify-between items-center p-3 bg-muted/30 rounded-lg border border-border/40">
                <span className="text-primary/40 text-[10px] font-normal uppercase">Time</span>
                <span className="text-primary font-normal text-xs">{timeLabel}</span>
              </div>
            )}
          </div>

          <button
            type="button"
            disabled={!canProceed}
            onClick={onProceed}
            className="hero-btn-primary premium-shine w-full inline-flex items-center justify-center rounded-full px-6 py-3.5 text-sm font-semibold uppercase tracking-[0.25em] disabled:opacity-40 disabled:grayscale disabled:cursor-not-allowed"
          >
            {isSubmitting ? 'Processing…' : 'Proceed to payment'}
          </button>
          <p className="text-center text-[10px] text-[#8B7355] flex items-center justify-center gap-1.5">
            <svg className="w-3 h-3" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <rect width="18" height="11" x="3" y="11" rx="2" />
              <path strokeLinecap="round" strokeLinejoin="round" d="M7 11V7a5 5 0 0 1 10 0v4" />
            </svg>
            Secure, encrypted checkout
          </p>
        </div>
      </div>
    </div>
  )
}
